import { IconIndicator } from "../../icons/IconIndicator/IconIndicator";
import { IconTrendArrow } from "../../icons/IconTrendArrow/IconTrendArrow";
import "./LeafTrendIndicator.scss";

export enum TrendEnum {
  HIGHER = "HIGHER",
  LOWER = "LOWER",
  EQUAL = "EQUAL",
}

export type Props = {
  trend: TrendEnum;
  number: number;
  preference?: TrendEnum;
  showDifference?: boolean;
  enableAnimation?: boolean;
  arrowType?: "default" | "trendArrow";
};

const LeafTrendIndicator = (props: Props) => {
  const {
    trend,
    number,
    preference = TrendEnum.HIGHER,
    showDifference = false,
    enableAnimation = false,
    arrowType,
  } = props;

  const getColorClass = () => {
    if (preference === TrendEnum.LOWER) {
      if (trend === TrendEnum.LOWER) return "green";
      if (trend === TrendEnum.EQUAL) return "grey";
      return "red";
    }
    if (preference === TrendEnum.HIGHER) {
      if (trend === TrendEnum.HIGHER) return "green";
      if (trend === TrendEnum.EQUAL) return "grey";
      return "red";
    }
    if (preference === TrendEnum.EQUAL) {
      if (trend === TrendEnum.EQUAL) return "green";
      return "red";
    }
  };

  const getTrendIcon = () => {
    if (arrowType === "trendArrow") {
      if (trend === TrendEnum.HIGHER) return <IconTrendArrow direction="up" color={"green"} />;

      if (trend === TrendEnum.LOWER) return <IconTrendArrow direction="down" color={"red"} />;

      return null;
    }

    if (trend === TrendEnum.HIGHER)
      return (
        <IconIndicator color={getColorClass()} orientation={"up"} animateTrigger={enableAnimation && number > 0} />
      );
    if (trend === TrendEnum.LOWER)
      return (
        <IconIndicator color={getColorClass()} orientation={"down"} animateTrigger={enableAnimation && number > 0} />
      );
    if (trend === TrendEnum.EQUAL)
      return (
        <IconIndicator color={getColorClass()} orientation={"left"} animateTrigger={enableAnimation && number > 0} />
      );
  };

  return (
    <div className={`leaf-trend-indicator ${showDifference ? "leaf-trend-indicator--with-difference" : ""}`}>
      <span className={`leaf-trend-indicator__trend-icon leaf-trend-indicator__${getColorClass()}`}>
        {getTrendIcon()}
        {showDifference && (
          <span className="leaf-trend-indicator__difference">
            {trend === TrendEnum.HIGHER ? "+" : trend === TrendEnum.LOWER ? "-" : ""}
            {Math.abs(number)}
          </span>
        )}
        {!showDifference && <span className="leaf-trend-indicator__trend-number">{number} </span>}
      </span>
    </div>
  );
};

export default LeafTrendIndicator;
